import { render, staticRenderFns } from "./TopStatisticChartV2.vue?vue&type=template&id=38346d96&scoped=true&"
import script from "./TopStatisticChartV2.vue?vue&type=script&lang=js&"
export * from "./TopStatisticChartV2.vue?vue&type=script&lang=js&"
import style0 from "./TopStatisticChartV2.vue?vue&type=style&index=0&id=38346d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38346d96",
  null
  
)

export default component.exports